<template>
  <div>
    <ul>
      <li class="infoList">
        <span class="infoListLeft">授信合同编号</span>
        <span class="infoListRight">{{this.otherPages.creditContractObj.credit_id}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">合同平台名称</span>
        <span class="infoListRight">{{this.otherPages.creditContractObj.plat_name}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">授信额度（小写）</span>
        <span class="infoListRight">¥{{this.otherPages.creditContractObj.loan_amt}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">授信额度（大写）</span>
        <span class="infoListRight">{{this.otherPages.creditContractObj.loan_amt_cn}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">支用起点金额（大写）</span>
        <span class="infoListRight">{{this.otherPages.creditContractObj.begin_amt_cn}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">授信额度有效期</span>
        <span class="infoListRight">{{this.otherPages.creditContractObj.loan_exp}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">授信起始日期</span>
        <span class="infoListRight">{{this.otherPages.creditContractObj.loan_start_date}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">授信到期日期</span>
        <span class="infoListRight">{{this.otherPages.creditContractObj.loan_end_date}}</span>
      </li>
    </ul>
    <Button
      :text="draw"
      :type="danger"
      class="nextStep"
      :click="clickAgree"
    />
    <div
      class="contractDraw"
      @click="viewLoanContract"
    >
      查看授信合同详情
    </div>
    <div
      v-show="isPopupShow"
      class="popupStyle"
    >
      <PufaLoan :hidePopup="hidePopup"></PufaLoan>
      <div v-if="forceRead" @click="forceReadSure" class="forceReadBtn" :class="forceReadText !== '我已阅读' ? 'disable' : ''">{{forceReadText}}</div>
    </div>
    <server-bank
      :productId="this.$route.query.productId"
      :isRelative="true"
    ></server-bank>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Button from '@/components/Button.vue';
import PufaLoan from '@/components/FeildTwo/components/PufaLoan.vue';
import ServerBank from '@/components/ServerBank.vue';
var clearIv = null;
export default {
  name: 'signContract',
  data() {
    return {
      count: 5,
      forceReadText: ``,
      forceReadFileArr: [],
      forceReadFile: '',
      forceRead: false,
      
      danger: 'danger',
      draw: '确认签署',
      isPopupShow: false,
    };
  },
  components: {
    Button,
    PufaLoan,
    ServerBank,
  },
  computed: mapState({
    otherPages(val) {
      return val.otherPages;
    },
  }),

  mounted() {
    this.$store.dispatch('otherPages/contCreditGenerateSpdb');
  },
  methods: {
    ...mapMutations('otherPages', ['updateForm']),
    forceReadSure() {
      if(this.forceReadText !== '我已阅读') return;
      clearInterval(clearIv);
      this.isPopupShow = false;
      this.forceRead = false;
      this.count = 5;
      // this.forceRead = true; // 如果阅读一次不需要再点击，打开注释和下面this.goToNextPage();即可
      this.goToNextPage();
    },
    clickAgree() {
      if(this.$route.query.productId === 'SPDB-FPD') {
        if(!this.forceRead) {
          this.count = 5;
          this.forceRead = true;
          this.isPopupShow = true;
          this.forceReadText = `我已阅读(${this.count--})`;
          clearIv = setInterval(() => {
            if(this.count > 0) {
              this.forceReadText = `我已阅读(${this.count--})`;
            } else {
              this.forceReadText = `我已阅读`;
            }
          }, 1000)
        } else {
          // this.goToNextPage();
          // this.count = !this.forceRead ? 5 : 0;
        }
      } else {
        this.goToNextPage();
      }
    },
    goToNextPage() {
      this.$store.dispatch('otherPages/signCreditGenerateSpdb');
    },
    viewLoanContract() {
      this.isPopupShow = true;
    },
    hidePopup() {
      this.forceRead = false;
      this.isPopupShow = false;
      clearInterval(clearIv);
    },
  },
};
</script>
<style scoped>
.popupStyle {
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 10;
}
.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
  border-bottom: 1px solid #eee;
}
.infoListLeft {
  color: rgba(56, 56, 56, 1);
  font-size: 14px;
}
.infoListRight {
  color: rgba(128, 128, 128, 1);
  font-size: 14px;
}
.nextStep {
  margin-top: 100px;
  margin-bottom: 12px;
}
.contractDraw {
  width: 92%;
  height: 40px;
  margin: auto;
  color: rgba(212, 48, 48, 1);
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  border: 1px solid rgba(212, 48, 48, 1);
  border-radius: 3px;
}
.forceReadBtn {
  width: 90%;
  background: #ff6538;
  color: #fff;
  border-radius: 4px;
  padding: 8px;
  position: fixed;
  left: 2.5%;
  bottom: 3px;
  z-index: 99;
}
.disable {
  background: #d7d7d7;
}
</style>
